import { render, staticRenderFns } from "./AdRotator.vue?vue&type=template&id=0a8ffcca&"
import script from "./AdRotator.vue?vue&type=script&lang=js&"
export * from "./AdRotator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports